import { useState } from 'react';
import { Button, Divider, Input, Modal } from 'antd';
import { apiDeleteProviderDataSponsorScheduler } from '../../api';
import {
    DeleteProviderDataSponsorSchedulerRequest,
    ProviderDataSponsorSchedulerItem
} from '../../interfaces/provider-data-sponsor-scheduler.interface';
import { systemProviderDataSponsorOptions } from '../../assets/constants/default_option';
import { toastError, toastSuccess } from '../../utils/toast';
import { useLoading } from '../../context/LoadingContext';

interface ModalDeleteProviderDataSponsorSchedulerProps {
    open: boolean;
    items: ProviderDataSponsorSchedulerItem[];
    onClose: () => void;
    onSuccess: () => void;
}

const getProviderDataSponsorLabel = (value: string) =>
    systemProviderDataSponsorOptions.find(item => item.value === value)?.label || value;

export default function ModalDeleteProviderDataSponsorScheduler({ open, items, onClose, onSuccess }: ModalDeleteProviderDataSponsorSchedulerProps) {
    const [otpConfirm, setOtpConfirm] = useState('');
    const { setIsLoading } = useLoading();

    const handleCancel = () => {
        setOtpConfirm('');
        onClose();
    };

    const handleDelete = async () => {
        try {
            if (!otpConfirm) {
                return toastError('Vui lòng nhập mã OTP xác nhận');
            }
            const payload: DeleteProviderDataSponsorSchedulerRequest = { otpConfirm };
            setIsLoading(true);
            const resp = await apiDeleteProviderDataSponsorScheduler(payload);
            if (resp.status === 200) {
                toastSuccess('Đã xoá lịch đổi nhà cung cấp đại trà');
                setOtpConfirm('');
                onSuccess();
                onClose();
            }
        } catch (error) {
            toastError('Có lỗi xảy ra');
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            title="Xoá lịch đổi nhà cung cấp đại trà"
            open={open}
            onCancel={handleCancel}
            footer={[
                <Button key="delete" onClick={handleDelete} type="primary" danger>
                    Xoá
                </Button>
            ]}
        >
            <p>Lịch đổi nhà cung cấp đại trà sẽ dừng ngay sau khi xoá.</p>
            {items.map(item => (
                <p key={item.time}><b>{item.time}</b>: {getProviderDataSponsorLabel(item.provider)}</p>
            ))}
            <p><span style={{ color: 'red' }}>*</span> Nhập mã OTP xác nhận</p>
            <Input value={otpConfirm} onChange={e => setOtpConfirm(e.target.value)} />
            <Divider />
        </Modal>
    );
}
